<template>
  <div class="pbz-font">
    <a-row class="d-flex align-items-center">
      <a-col :span="1" class="d-flex justify-content-start">
        <div style="cursor: pointer">
          <router-link
            :to="to(`/warehouse`)"
          >
            <ArrowIcon
              class="ant-dropdown-link"
              style="color: #E00000; height: 100px; width: 25px"
              :rotate="'rotate(270)'"
            />
          </router-link>
        </div>
      </a-col>
      <div class="pbz-font body-md-bold mr-3">
        {{ isEdit ? $t('warehouse.edit_warehouse') : $t('warehouse.add_warehouse') }}
      </div>
      <a-col
        class="d-flex justify-content-start align-items-center"
        :span="10"
        style="border-left: 1px solid rgb(204, 204, 204)"
      >
        <div
          class="ml-4"
          style="color: #006BD1; margin-right: 5px"
        >
          {{ $t('warehouse.list_warehouse') }} >
        </div>
        {{ isEdit ? $t('warehouse.edit_warehouse') : $t('warehouse.add_warehouse') }}
      </a-col>
    </a-row>

    <div class="add-distributor-container">
      <a-form-model ref="ruleForm" class="mb-4" :model="form">
        <a-row>
          <a-col :span="24" class="mb-2">
            <a-row class="input-warehouse-container px-5 py-3 bg-white rounded-lg">
              <div class="pbz-font body-md-bold mb-4 mt-2">
                {{ isEdit ? $t('warehouse.edit_warehouse') : $t('warehouse.add_warehouse') }}
              </div>
              <a-col :span="24" class="d-flex flex-column">
                <a-form-model-item
                  prop="name"
                  :label="$t('warehouse.name_warehouse')"
                  :rules="nameRules"
                >
                  <a-input
                    v-model="form.name"
                    class="input"
                    :placeholder="$t('warehouse.placeholder.name')"
                    :disabled="loading"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24" class="d-flex flex-column">
                <a-form-model-item
                  prop="warehouse_code"
                  :label="$t('warehouse.code_warehouse')"
                  :rules="codeRules"
                >
                  <a-input
                    v-model="form.warehouse_code"
                    class="input"
                    :placeholder="$t('warehouse.placeholder.code')"
                    :disabled="loading"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24" class="d-flex flex-column">
                <a-form-model-item
                  prop="ext_code"
                  :label="$t('warehouse.externalCode')"
                  :rules="extCodeRules"
                >
                  <a-input
                    v-model="form.ext_code"
                    class="input"
                    :placeholder="$t('warehouse.placeholder.ext_code')"
                    :disabled="loading"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24" class="d-flex flex-column">
                <a-form-model-item
                  prop="contact_name"
                  :label="$t('warehouse.warehousePIC')"
                  :rules="[
                    {
                      required: true,
                      message: $t('warehouse.validation.pic_required'),
                    },
                  ]"
                >
                  <a-input
                    v-model="form.contact_name"
                    class="input"
                    :placeholder="$t('warehouse.placeholder.pic')"
                    :disabled="loading"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="24" class="d-flex flex-column">
                <a-form-model-item
                  prop="contact_phone"
                  :label="$t('warehouse.phoneNumber')"
                  :rules="[
                    {
                      required: true,
                      message: $t('warehouse.validation.phone_required'),
                    },
                  ]"
                >
                  <a-input
                    v-model="form.contact_phone"
                    class="select-input"
                    :placeholder="$t('warehouse.placeholder.phone')"
                    :disabled="loading"
                  >
                    <a-select
                      slot="addonBefore"
                      v-model="form.ext_phone"
                      class="select-phone-code"
                      option-label-prop="children"
                      :disabled="loading"
                    >
                      <a-select-option
                        v-for="(item, index) in codeCountry"
                        :key="index"
                        :value="item.value"
                        :label="item.value"
                        class="d-flex"
                      >
                        <keep-alive>
                          <component :is="flagComponent(item.value)" />
                        </keep-alive>
                        <p style="margin-left: 10px">
                          {{ item.label }}
                        </p>
                      </a-select-option>
                    </a-select>
                  </a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row class="mt-3 input-warehouse-container px-5 py-3 bg-white rounded-lg">
              <div class="pbz-font body-md-bold mb-4 mt-2">
                {{ $t('warehouse.address_warehouse') }}
              </div>
              
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-form-model-item
                    prop="country_id"
                    :label="$t('warehouse.country')"
                    :rules="[{
                      required: true,
                      message: $t('warehouse.validation.country_required'),
                    }]"
                  >
                    <a-spin :spinning="loadingCountries">
                      <a-select
                        v-model="form.country_id"
                        show-arrow
                        show-search
                        :filter-option="filterOption"
                        :disabled="loading"
                        @change="handleChangeCountry"
                      >
                        <a-select-option v-for="country in countries" :key="country.value" :value="country.value" :title="country.label">
                          {{ country.label }}
                        </a-select-option>
                      </a-select>
                    </a-spin>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item
                    prop="city_id"
                    :label="$t('warehouse.city')"
                    :rules="[
                      {
                        required: true,
                        message: $t('warehouse.validation.city_required'),
                      },
                    ]"
                  >
                    <a-input
                      v-if="isManualInputCountry"
                      v-model="form.city_id"
                      :disabled="loading"
                    />
                    <a-select
                      v-else
                      v-model="form.city_id"
                      show-arrow
                      show-search
                      :filter-option="filterOption"
                      :not-found-content="loadingCities ? undefined : null"
                      :disabled="loading || !(!!form.country_id)"
                      @change="onChangeCity"
                      @focus="getCities"
                    >
                      <a-spin v-if="loadingCities" slot="notFoundContent" size="small" />
                      <a-select-option v-for="city in cities" :key="city.value" :value="city.value" :title="city.label">
                        {{ city.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="16">
                <a-col v-if="!isManualInputCountry" :span="12">
                  <a-form-model-item
                    prop="subdistrict_id"
                    :label="$t('warehouse.district')"
                    :rules="[
                      {
                        required: true,
                        message: $t('warehouse.validation.district_required'),
                      },
                    ]"
                  >
                    <a-select
                      v-model="form.subdistrict_id"
                      show-arrow
                      show-search
                      :filter-option="filterOption"
                      :disabled="loading || !(!!form.city_id)"
                      :not-found-content="loadingSubdistrict ? undefined : null"
                      @change="onChangeDistrict($event, '')"
                      @focus="getSubdistrict"
                    >
                      <a-select-option
                        v-if="!form.city_id"
                        key="novalid"
                        value=""
                        disabled
                        class="text-dark"
                      >
                        {{ $t('warehouse.please_select_city') }}
                      </a-select-option>
                      <a-spin v-else-if="loadingSubdistrict && form.city_id" slot="notFoundContent" size="small" />
                      <a-select-option v-for="sub in subdistricts" :key="sub.value" :value="sub.value" :title="sub.label">
                        {{ sub.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item
                    prop="postal_code"
                    :label="$t('warehouse.postalCode')"
                    :rules="[
                      {
                        required: true,
                        message: $t('warehouse.validation.postal_code_required'),
                      },
                    ]"
                  >
                    <a-input
                      v-model="form.postal_code"
                      :read-only="!isManualInputCountry"
                      :disabled="loading || (!isManualInputCountry && !(!!form.subdistrict_id))"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-form-model-item
                prop="street_name"
                :label="$t('warehouse.address_warehouse')"
                :rules="[
                  {
                    required: true,
                    message: $t('warehouse.validation.address_required'),
                  },
                ]"
              >
                <a-textarea
                  v-model="form.street_name"
                  :auto-size="{ minRows: 2, maxRows: 9 }"
                  :disabled="loading"
                />
              </a-form-model-item>
            </a-row>

            <a-row class="mt-3 input-warehouse-container px-5 py-3 bg-white rounded-lg">
              <div class="pbz-font body-md-bold mb-4 mt-2">
                {{ $t('warehouse.integration_warehouse') }}
              </div>
              <a-col :span="24" class="d-flex justify-content-start mb-3">
                <a-radio-group
                  :value="warehouseIntegrationType"
                  :disabled="loading"
                  class="checkbox-input text-note d-flex mb-2"
                  @change="handleWhsIntegrationType"
                >
                  <a-radio value="not_connected">
                    {{ $t('warehouse.not_connected_wms') }}
                  </a-radio>
                  <a-radio value="javelin">
                    {{ $t('warehouse.connected_javelin') }}
                  </a-radio>
                  <a-radio value="jubelio">
                    {{ $t('warehouse.connected_jubelio') }}
                  </a-radio>
                </a-radio-group>
              </a-col>

              <a-col v-if="warehouseIntegrationType === 'javelin'" :span="24" class="d-flex flex-column">
                <a-form-model-item
                  prop="auth_key"
                  :label="$t('warehouse.auth_key')"
                  :rules="[
                    {
                      required: true,
                      message: $t('warehouse.validation.auth_key_required'),
                    },
                  ]"
                >
                  <a-input
                    v-model="form.auth_key"
                    class="input"
                    :placeholder="$t('warehouse.placeholder.auth_key')"
                    :disabled="loading"
                  />
                </a-form-model-item>
              </a-col>
              <a-col v-if="warehouseIntegrationType === 'javelin'" :span="24" class="d-flex flex-column">
                <a-form-model-item
                  prop="secret_key"
                  :label="$t('warehouse.secret_key')"
                  :rules="[
                    {
                      required: true,
                      message: $t('warehouse.validation.secret_key_required'),
                    },
                  ]"
                >
                  <a-input
                    v-model="form.secret_key"
                    class="input"
                    :placeholder="$t('warehouse.placeholder.secret_key')"
                    :disabled="loading"
                  />
                </a-form-model-item>
              </a-col>
              <a-col v-if="warehouseIntegrationType === 'javelin'" :span="24" class="d-flex flex-column">
                <a-form-model-item
                  prop="api_url_javelin"
                  :label="$t('warehouse.api_url')"
                  :rules="[
                    {
                      required: true,
                      message: $t('warehouse.validation.api_url_required'),
                    },
                  ]"
                >
                  <a-input
                    v-model="form.api_url_javelin"
                    class="input"
                    :placeholder="$t('warehouse.placeholder.api_url')"
                    :disabled="loading"
                  />
                </a-form-model-item>
              </a-col>

              <a-col v-if="warehouseIntegrationType === 'jubelio'" :span="24" class="d-flex flex-column">
                <a-form-model-item
                  prop="username"
                  :label="$t('warehouse.username')"
                  :rules="[
                    {
                      required: true,
                      message: $t('warehouse.validation.username_required'),
                    },
                  ]"
                >
                  <a-input
                    v-model="form.username"
                    class="input"
                    :placeholder="$t('warehouse.placeholder.username')"
                    :disabled="loading"
                  />
                </a-form-model-item>
              </a-col><a-col v-if="warehouseIntegrationType === 'jubelio'" :span="24" class="d-flex flex-column">
                <a-form-model-item
                  prop="password"
                  :label="$t('warehouse.password')"
                  :rules="[
                    {
                      required: true,
                      message: $t('warehouse.validation.password_required'),
                    },
                  ]"
                >
                  <a-input
                    v-model="form.password"
                    class="input"
                    type="password"
                    :placeholder="$t('warehouse.placeholder.password')"
                    :disabled="loading"
                  />
                </a-form-model-item>
              </a-col>
              <a-col v-if="warehouseIntegrationType === 'jubelio'" :span="24" class="d-flex flex-column">
                <a-form-model-item
                  prop="api_url_jublio"
                  :label="$t('warehouse.api_url')"
                  :rules="[
                    {
                      required: true,
                      message: $t('warehouse.validation.api_url_required'),
                    },
                  ]"
                >
                  <a-input
                    v-model="form.api_url_jublio"
                    class="input"
                    :placeholder="$t('warehouse.placeholder.api_url')"
                    :disabled="loading"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <a-row class="mt-3 bg-white footer-container d-flex py-3 px-5 align-items-center">
          <a-col :span="16">
            <div class="d-flex">
              <div v-for="(item, index) in step_form" :key="index" :class="`d-flex align-items-center ${item.status ? 'step-container-active' : 'step-container'}`">
                <div class="number px-3 py-1 rounded-lg">
                  {{ index + 1 }}
                </div>
                <div>{{ $t(item.name) }}</div>
                <i v-if="index+1 < step_form.length" class="icon-right-arrow font-size-24 mr-2" />
              </div>
            </div>
          </a-col>
          <a-col :span="8">
            <a-row>
              <a-col :span="12">
                <a-button class="cancel-button" :disabled="loading">
                  <router-link
                    :to="to('/warehouse')"
                  >
                    {{ $t('warehouse.setup_product.btn_cancel') }}
                  </router-link>
                </a-button>
              </a-col>
              <a-col :span="12">
                <a-button class="submit-button px-4" :loading="loading" @click.prevent="handleSubmit">
                  {{ isEdit ? $t('common.save') : $t('warehouse.add_warehouse') }}
                </a-button>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <ModalConfirmationAdjustmentProduct
      :form="form"
      :visible="showModalConfirmationAdjustmentProduct"
      :whs-id="responseAddWarehouseId"
      @handleModal="handleShowModalConfirmationAdjustmentProduct"
    />
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { getArea, getParentArea } from '@/api/data'
import { getAreas } from '@/api/business'
import { getWarehouseById, crudWarehouseInternal } from '@/api/warehouse'
import ArrowIcon from '@/components/Icons/Arrow.vue'
import IndonesiaFlag from '@/components/Icons/IndonesiaFlag.vue'
import MalaysiaFlag from '@/components/Icons/MalaysiaFlag.vue'
import SingaporeFlag from '@/components/Icons/SingaporeFlag.vue'
import SouthAfricaFlag from '@/components/Icons/SouthAfricaFlag.vue'
import useQueryParam from '@/composable/useQueryParam'
import ModalConfirmationAdjustmentProduct from '@/views/setting/warehouse/ModalConfirmationAdjustmentProduct.vue'

export default {
  components: {
    ArrowIcon,
    IndonesiaFlag,
    MalaysiaFlag,
    SingaporeFlag,
    SouthAfricaFlag,
    ModalConfirmationAdjustmentProduct,
  },
  setup() {
    const { to } = useQueryParam()

    return { to }
  },
  data() {
    return {
      form: {
        name: '',
        warehouse_code: '',
        ext_code: '',
        contact_name: '',
        ext_phone: '',
        contact_phone: '',
        country_id: '',
        city_id: '',
        subdistrict_id: '',
        postal_code: '',
        street_name: '',
        auth_key: '',
        secret_key: '',
        api_url_javelin: '',
        username: '',
        password: '',
        api_url_jublio: '',
      },
      warehouseIntegrationType: 'not_connected',
      codeCountry: [],
      countries: [],
      cities: [],
      subdistricts: [],
      distributors: [],
      loadingCountries: false,
      loadingCities: true,
      loadingSubdistrict: true,
      loadingDistributor: true,
      loading: false,
      showModalConfirmationAdjustmentProduct: false,
      responseAddWarehouseId: null,
      parentAreaId: [],
      fieldErrors: {
        name: '',
        warehouse_code: '',
        ext_code: '',
      },
    }
  },
  computed: {
    nameRules() {
      return [
        {
          required: true,
          message: this.$t('warehouse.validation.name_required'),
        },
        {
          validator: (rule, value, callback) => {
            if (this.fieldErrors.name) {
              callback(new Error(this.fieldErrors.name))
            } else {
              callback()
            }
          },
        },
      ]
    },
    codeRules() {
      return [
        {
          required: true,
          message: this.$t('warehouse.validation.code_required'),
        },
        {
          validator: (rule, value, callback) => {
            if (this.fieldErrors.warehouse_code) {
              callback(new Error(this.fieldErrors.warehouse_code))
            } else {
              callback()
            }
          },
        },
      ]
    },
    extCodeRules() {
      return [
        {
          required: true,
          message: this.$t('warehouse.validation.ext_code_required'),
        },
        {
          validator: (rule, value, callback) => {
            if (this.fieldErrors.ext_code) {
              callback(new Error(this.fieldErrors.ext_code))
            } else {
              callback()
            }
          },
        },
      ]
    },
    businessId() {
      return this.$store.state.user.restriction_base === 'Warehouse'
        ? Object.keys(this.$store.getters['user/businessListObjectByKey'])[0]
        : this.$route.query.business_id
    },
    countryId() {
      return this.$store.getters['user/businessListObjectByKey'][this.businessId]?.area_id || 228
    },
    manualInputCountryIds() {
      return ['126', '180', '185', 126, 180, 185] // Malaysia, Singapore, South Africa
    },
    isManualInputCountry() {
      return this.manualInputCountryIds.includes(this.form.country_id)
    },
    step_form() {
      const steps = [
        {
          name: 'warehouse.information_warehouse',
          status: false,
        },
        {
          name: 'warehouse.address_warehouse',
          status: false,
        },
      ]
      if (!this.isEdit) {
        steps.push({
          name: 'warehouse.integration_warehouse',
          status: false,
        })
      }
      return steps
    },
    isEdit() {
      return Boolean(this.$route.params.id)
    },
  },
  watch: {
    'form.name'() {
      if (this.fieldErrors.name) {
        this.fieldErrors.name = ''
        if (this.$refs.ruleForm) this.$refs.ruleForm.validateField('name')
      }
    },
    'form.warehouse_code'() {
      if (this.fieldErrors.warehouse_code) {
        this.fieldErrors.warehouse_code = ''
        if (this.$refs.ruleForm) this.$refs.ruleForm.validateField('warehouse_code')
      }
    },
    'form.ext_code'() {
      if (this.fieldErrors.ext_code) {
        this.fieldErrors.ext_code = ''
        if (this.$refs.ruleForm) this.$refs.ruleForm.validateField('ext_code')
      }
    },
  },
  mounted() {
    this.getAreaList()
    if (this.isEdit) this.getDetailWarehouseInternal(this.$route.params.id)
  },
  methods: {
    handleChangeCountry() {
      this.form.city_id = ''
      this.form.subdistrict_id = ''
      this.form.postal_code = ''
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate(['city_id', 'subdistrict_id', 'postal_code'])
      }
    },
    handleShowModalConfirmationAdjustmentProduct(param) {
      this.showModalConfirmationAdjustmentProduct = param
    },
    async getAreaList() {
      this.loadingCountries = true
      await getAreas({
        business_id: this.$route.query.business_id,
        params: {
          parent_id: 0,
          is_active: true,
        },
      })
      .then(({ data }) => {
        let areaList = []
        let phoneList = []
        data?.forEach(item => {
          areaList.push({
            ...item,
            value: item.id,
            label: item.area_name,
          })
          phoneList.push({
            value: item.area_phone,
            label: `+${item.area_phone}`,
          })
        })
        this.countries = areaList
        this.codeCountry = phoneList
      })
      .catch(() => {
        this.countries = []
        this.codeCountry = []
      })
      .finally(() => {
        this.form.country_id = this.countryId
        this.form.ext_phone = this.countries?.find(country => country.id == this.countryId)?.area_phone || '62'
        this.loadingCountries = false
      })
    },
    async getDetailWarehouseInternal(id) {
      await getWarehouseById(id)
      .then(({ data: { data: response } }) => {
        const ext_phone = response?.phone?.charAt(0) == '0'
          ? '62'
          : response?.phone?.length > 2
          ? response.phone.substring(0, 2)
          : ''
        this.form = {
          ...this.form,
          ...response,
          name: response?.name,
          warehouse_code: response?.warehouse_code,
          ext_code: response?.ext_code,
          contact_name: response?.warehouse_contact,
          ext_phone: (ext_phone == '60' || ext_phone == '62')
            ? ext_phone
            : '62',
          contact_phone: response?.phone && (ext_phone == '60' || ext_phone == '62')
            ? response.phone.substring(2)
            : response?.phone,
          postal_code: response?.code_pos,
          street_name: response?.address_line?.replace(' null', ''),
          auth_key: response?.wms_code === 'javelin' ? response?.param1 : '',
          secret_key: response?.wms_code === 'javelin' ? response?.param2 : '',
          api_url_javelin: response?.wms_code === 'javelin' ? response?.param3 : '',
          username: response?.wms_code === 'jubelio' ? response?.param1 : '',
          password: response?.wms_code === 'jubelio' ? response?.param2 : '',
          api_url_jublio: response?.wms_code === 'jubelio' ? response?.param3 : '',
        }
        const currentCountryId = this.countries?.find((obj) => obj.label === response?.country)?.value
        if (currentCountryId) {
          this.form.country_id = currentCountryId
          if (this.manualInputCountryIds.includes(currentCountryId)) {
            this.form.city_id = response?.city
            this.form.subdistrict_id = response?.province
          } else {
            this.getCities(currentCountryId)
          }
        }
        this.warehouseIntegrationType = response?.wms_code
          ? response?.wms_code
          : 'not_connected'
        if (response?.area_id) this.onChangeDistrict(response.area_id, 'init')
      })
      .catch((err) => {
        this.form = {
          name: '',
          warehouse_code: '',
          ext_code: '',
          contact_name: '',
          ext_phone: '62',
          contact_phone: '',
          country_id: '',
          city_id: '',
          subdistrict_id: '',
          postal_code: '',
          street_name: '',
          auth_key: '',
          secret_key: '',
          api_url_javelin: '',
          username: '',
          password: '',
          api_url_jublio: '',
        }
        this.$notification.error({
          message: err?.response?.data?.message || 'id not found',
        })
      })
    },
    phoneRule(e) {
      if (/^\D$/.test(e.key)) {
        e.preventDefault()
      }
    },
    flagComponent(param) {
      if (param === '62' || param === 'Indonesia') return IndonesiaFlag
      if (param === '60') return MalaysiaFlag
      if (param === '65') return SingaporeFlag
      if (param === '27') return SouthAfricaFlag
    },
    handleWhsIntegrationType(value) {
      this.warehouseIntegrationType = value?.target?.value
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate('auth_key')
        this.$refs.ruleForm.clearValidate('secret_key')
        this.$refs.ruleForm.clearValidate('api_url_javelin')
        this.$refs.ruleForm.clearValidate('username')
        this.$refs.ruleForm.clearValidate('password')
        this.$refs.ruleForm.clearValidate('api_url_jublio')
      }
    },
    scrollToError() {
      this.$nextTick(() => {
        const errorField = document.querySelector('.has-error') || document.querySelector('.ant-form-item-has-error')
        if (errorField) {
          errorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          this.loading = true
          this.onSaveWarehouse()
        } else {
          this.scrollToError()
        }
      })
    },
    onSaveWarehouse: debounce(async function() {
      const { name, warehouse_code, ext_phone, contact_phone, contact_name, country_id, city_id, subdistrict_id, street_name, auth_key, secret_key, api_url_javelin, username, password, api_url_jublio, ext_code, postal_code } = this.form
      let currentParentAreaId = null
      if (!this.manualInputCountryIds.includes(country_id)) {
        currentParentAreaId = {
          province_id: this.parentAreaId[1]?.id ? String(this.parentAreaId[1]?.id) : null,
          district_id: this.parentAreaId[3]?.id ? String(this.parentAreaId[3]?.id) : null,
        }
      }

      const isManual = this.manualInputCountryIds.includes(country_id)
      const provinceName = !isManual
        ? this.cities?.find((obj) => obj.value === city_id)?.label?.split(' - ')
        : subdistrict_id
      const districtName = !isManual
        ? this.subdistricts?.find((obj) => obj.value === subdistrict_id)?.label?.split(' - ')
        : city_id
      let type = 'save'
      let payload = {
        name,
        code: warehouse_code,
        contact_phone: ext_phone + contact_phone,
        contact_name,
        business_id: this.$route.query.business_id,
        ext_code,
        address : {
          country_id,
          country_name: this.countries?.find((obj) => obj.value === country_id)?.label,
          province_id: currentParentAreaId?.province_id || null,
          province_name: !isManual ? (provinceName?.[1] || '') : (provinceName || ''),
          city_id: !isManual ? city_id : null,
          city_name: !isManual ? (provinceName?.[0] || '') : (districtName || ''),
          district_id: currentParentAreaId?.district_id || null,
          district_name: !isManual ? (districtName?.[1] || '') : null,
          sub_district_id: !isManual ? subdistrict_id : null,
          sub_district_name: !isManual ? (districtName?.[0] || '') : null,
          postal_code,
          street_name,
        },
        wms_categories: this.warehouseIntegrationType === 'not_connected' ? 'SIMPLE INVENTORY' : 'EXTERNAL WMS',
      }

      if (this.warehouseIntegrationType !== 'not_connected') {
        payload = {
          ...payload,
          wms_code: this.warehouseIntegrationType,
          param1: this.warehouseIntegrationType === 'javelin' ? auth_key : username,
          param2: this.warehouseIntegrationType === 'javelin' ? secret_key : password,
          param3: this.warehouseIntegrationType === 'javelin' ? api_url_javelin : api_url_jublio,
        }
      }

      if (this.isEdit) {
        payload.id = this.$route.params.id
        type = 'update'
      }

      await crudWarehouseInternal({ type, data: payload })
      .then(({ data: { data: res } }) => {
        if (res?.id) {
          this.responseAddWarehouseId = res?.id
          this.$notification.success({
            message: this.$t('warehouse.success_save'),
          })
          if (type === 'save') {
            this.showModalConfirmationAdjustmentProduct = true
          } else {
            this.$router.push({
              path: '/warehouse',
              query: this.$route.query,
            })
          }
        }
      })
      .catch((err) => {
        const status = err?.response?.data?.status
        const errors = err?.response?.data?.errors
        const message = err?.response?.data?.message
        if (status === 400 && Array.isArray(errors) && errors.length) {
          // Map API fieldName → form prop
          const fieldMap = {
            name: { prop: 'name', key: 'name_exist' },
            code: { prop: 'warehouse_code', key: 'code_exist' },
            extCode: { prop: 'ext_code', key: 'ext_code_exist' },
          }
          const fieldsToValidate = []
          errors.forEach(err => {
            const mapped = fieldMap[err.fieldName]
            if (mapped) {
              this.fieldErrors[mapped.prop] = this.$t(`warehouse.validation.${mapped.key}`)
              fieldsToValidate.push(mapped.prop)
            }
          })
          if (this.$refs.ruleForm && fieldsToValidate.length) {
            this.$refs.ruleForm.validateField(fieldsToValidate)
          }
          this.scrollToError()
        } else {
          this.$notification.error({
            message: message || err?.message || 'Error occurred',
          })
        }
      })
      .finally(() => this.loading = false)
    }, 600),
    async getCities(id) {
      if (this.loadingCities) {
        await getArea({
          businessId: this.$route.query.business_id,
          params: { parentId: id ?? '228' },
        })
        .then(res => {
          const list = res?.data?.list
          if (list) {
            this.cities = list
            this.loadingCities = false
            if (this.$route.params.id) {
              const currentCityId = list?.find((obj) => obj.label === `${this.form.city} - ${this.form.province}`)?.value
              if (currentCityId) {
                this.form.city_id = currentCityId
                this.getSubdistrict(currentCityId)
              }
            }
          }
        })
        .catch(() => {})
      }
    },
    async getSubdistrict(id) {
      if (this.loadingSubdistrict && this.form.city_id) {
        await getArea({
          businessId: this.$route.query.business_id,
          params: { parentId: id ?? this.form.city_id },
        })
        .then(res => {
          const list = res?.data?.list
          if (list) {
            this.subdistricts = list
            this.loadingSubdistrict = false
            if (this.$route.params.id) {
              const currentSubdistrictId = list?.find((obj) => obj.label === `${this.form.sub_district} - ${this.form.district}`)?.value
              if (currentSubdistrictId) {
                this.form.subdistrict_id = currentSubdistrictId
              }
            }
          }
        })
        .catch(() => {})
      }
    },
    onChangeCity() { // val, option
      this.subdistricts = []
      this.loadingSubdistrict = true
      this.form.subdistrict_id = ''
      this.form.postal_code = ''
    },
    async onChangeDistrict(e, type = '') {
      const findSelectedSubdistrict = this.subdistricts?.find((obj) => obj.value === e)
      if (!type) this.form.postal_code = findSelectedSubdistrict?.postcode
      if (e && !this.manualInputCountryIds.includes(this.form.country_id)) {
        try {
          const { data } = await getParentArea({ area_id: e })
          if (data?.message?.length > 0) {
            this.parentAreaId = data.message
          } else {
            this.parentAreaId = []
          }
        } catch (error) {
          console.error(error)
          this.form.subdistrict_id = ''
          this.form.postal_code = ''
          this.$notification.error({
            message: 'Gagal',
            description: 'Terjadi kesalahan saat mengambil data area.',
          })
        }
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
}
</script>

<style lang="scss" scoped>
.add-distributor-container {
  .border-distributor {
    border: 1px solid #cccccc;
    border-radius: 8px;
  }
  .submit-button {
    background: #E00000;
    color: #fff;
    border-radius: 5px;
  }
  .cancel-button {
    width: 100%;
    color: #E00000;
    border: 0px;
    border-radius: 5px;
    cursor: pointer;
  }

}
.footer-container {
  position: sticky;
  bottom: 0;
  margin: 0px -35px -20px -35px;
}
.step-container {
  gap: 0px 10px;
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.01em;
  text-align: left;
  color: #878F97;
  .number {
    background-color: #F4F5F6;
  }
}
.step-container-active {
  gap: 0px 10px;
  font-size: 13px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.01em;
  text-align: left;
  color: #2196F3;
  .number {
    background-color: #E3F2FD;
  }
}
</style>

<style lang="scss">
  .input-warehouse-container {
    border-radius: 8px;

    .warehouse-list {
      border: 1px solid #CCCCCC;
      border-radius: 8px;
      text-align: left;
    }
    .title {
      font-weight: 500;
      font-size: 20px;
      margin-bottom: 5px;
    }
    .label-form {
      position: absolute;
      left: 15px;
      top: -11px;
      background: #FFFFFF;
      color: #B3B3B3;
    }

    .tag-box {
      display: inline-flex;
      position: static;
      width: auto;
      height: 31px;
      background: #4D4D4D;
      box-shadow: 0px 5px 5.3625px rgba(0, 0, 0, 0.055);
      border-radius: 33px;
      margin: 0 5px;
      padding: 5px 15px;
      p {
        position: static;
        color: #ffffff;
        align-items: center;
        text-align: center;
      }
    }
    .x-button {
      color:#ffffff;
      background:#4D4D4D;
      border:none;
      line-height: 21px;
      padding: 0 0 5px 7px;
    }
    .input {
      max-height: 48px;
      min-height: 30px;
    }
    .select-input {
      input:focus {
        border: 1px solid #4b7cf3;
      }
      .ant-input {
        border: 1px solid #e4e9f0;
        border-left: none;
      }
      .ant-select-selection.ant-select-selection--single {
        border-bottom-right-radius: 0;
        background-color: #ffffff;
        border: 1px solid #e4e9f0;
        border-right: none;
        width: 100px;
        margin-top: -36px !important;
      }
      .ant-select-selection-selected-value {
        margin-top: 6px;
        display: flex !important;
      }
      form .ant-input-group .ant-select {
        height: 0px;
      }
      .ant-input-group-addon {
        background-color: transparent !important;
        border: none !important;
      }
      .ant-input-group-addon:first-child .ant-select .ant-select-selection {
        margin-top: 5px !important;
      }
    }
    .checkbox-input {
      gap: 4px 0px;
      @media (max-width: 1200px) {
        flex-direction: column;
      }
      .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #E00000;
        border-color: #E00000;
      }
    }
    .radio-input {
      .ant-radio-checked .ant-radio-inner {
        border-color: #E00000;
      }
      .ant-radio-inner::after{
        background-color: #E00000;
      }
    }
    .submit-button {
      background: #E00000;
      color: #FFFFFF;
      border-radius: 5px;
    }
    .cancel-button {
      background: #FFFFFF;
      border: 1px solid #E00000;
      color: #E00000;
      border-radius: 5px;
    }
    .text-select {
      font-weight: 500;
      font-size: 16px;
    }
    .text-note {
      font-weight: 400;
      font-size: 1em;
      color: #999999;
      text-align: left;
      margin-top: 5px;
    }
    .button-input {
      width: 90%;
      height: 48px;
      background: #E00000;
      color: #FFFFFF;
      font-weight: 800;
    }
    .ant-select-selection__placeholder {
      color: #999999;
      margin-top: 0px;
    }
  }
  .select-phone-code {
    .ant-select-selection__rendered {
      line-height: 20px;
    }
  }
</style>
